import { EventEmitter } from "events";

import {
	isString,
	isObject,
	isArray
} from "@teaming/common-util";

export const global = Object.create( new EventEmitter() );

window.document.body.addEventListener( "click", function globalClickHandler( e ) {
	if ( global.listenerCount( "click" ) === 0 ) {
		return;
	}
	const path = ( e.path || ( e.composedPath && e.composedPath() ) ) || [];
	const classPath = path
		.filter( element => !!element.className )
		.map( element => element.className );
	global.emit( "click", {
		classPath,
	} );
} );

/**
 *
 * @param {String} className
 * @param {Function} callback
 * @returns {Function}
 * @code
 * created() {
 * 		const { global, } = this.$foundation();
 * 		this.handler = global.onClickOutside( "my-component-class", async () => {
 * 			// click happened outside of this component
 * 		} );
 * 	},
 */
global.onClickOutside = ( className, callback ) => {
	const internalCallback = e => {
		const classInPath = e.classPath.find( classes => {
			let classArray = [];
			if ( isArray( classes ) ) {
				classArray = classes;
			} else if ( isString( classes ) ) {
				classArray = classes.split( " " );
			} else if ( isObject( classes ) ) {
				classArray = Object.values( classes );
			}
			return classArray.includes( className );
		} );
		if ( !classInPath ) {
			return callback( e );
		}
	};

	global.on( "click", internalCallback );

	return internalCallback;
};

/**
 * @param {Function} callback - callback returned from global.onClickOutside()
 * @code
 * beforeUnmount() {
 * 		const { global, } = this.$foundation();
 * 		global.offClickOutside( this.handler );
 * 		this.handler = null;
 * 	},
 */
global.offClickOutside = callback => {
	global.off( "click", callback );
};
